import { Image } from '@mantine/core';
import { To } from 'react-router-dom';
import { LogoIcon } from '../../../assets/Icons';
import { NavLinkCon } from './style';

type LinkProps = {
  to: To;
  label: string;
  img?: any;
  Icon?: any;
  isActive?: boolean;
  onImageError?: () => void;
};

export type navLinkProps = Omit<LinkProps, 'isActive'>;

export const FrontNavLinks = ({ to, label, img, Icon, isActive, onImageError }: LinkProps) => {
  return (
    <NavLinkCon to={to} className={isActive ? 'nav-link--active' : ''}>
      <div className="navIcon">
        {img ? (
          <Image
            alt="icon"
            src={img}
            onError={onImageError}
          />
        ) : (
          <LogoIcon />
        )}
      </div>
      {Icon && <Icon />}
      {label}
    </NavLinkCon>
  );
};